import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { KeyValues15, LocalService, Paging, ServiceApiType, ServiceType, Status } from '../../../service/local.service';
import { environment } from './../../../environments/environment';
import { service_controllers_methods } from './../../../service/service_controllers_methods';

@Injectable({
  providedIn: "root"
})

@Component({
  selector: 'app-http-request',
  templateUrl: './http-request.component.html',
  styleUrls: ['./http-request.component.scss']
})
export class HttpRequestComponent implements OnInit {
  activeServiceCallsCount: number = 0;
  private controllerNameConfiguration = service_controllers_methods.configuration.controller;
  private methodsConfiguration = service_controllers_methods.configuration.methods;

  constructor(public localService: LocalService, private httpCall: HttpClient, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
  }

  request_general_post(controllerMethod: string, body?, isShowSpinner = true, isRawJsonString: boolean = false, isBulkService: boolean = false, isForceBackupService = false) {
    this.localService.isInternetAvailable = navigator.onLine;
    if (this.localService.isInternetAvailable) {
      const generalOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'POST',
          'Access-Control-Max-Age': '300',
          'Access-Control-Allow-Methods': '*'
        })
      };
      if (!isRawJsonString && body && body.pag) {
        body.pag = this.convertFromPaging(body.pag);
      }
      const isEncryptionAvailable = this.localService.reques ? true : false;
      let encryptedBody = isEncryptionAvailable && !isRawJsonString ? this.localService.encryptCrypto(JSON.stringify(body)) : body;
      this.showHideSpinner(true, isShowSpinner);
      const url = ((isForceBackupService || this.localService.isPrimaryServiceDown) ? environment.url.bkp_service : (isBulkService ? environment.url.bulk_service : environment.url.service)) + controllerMethod;
      return Observable.create(observer => this.httpCall.post(url, isEncryptionAvailable ? { "val": encryptedBody } : { "val_no_encr": encryptedBody }, generalOptions).subscribe(
        data => {
          if (!isBulkService && this.localService.isPrimaryServiceDown) {
            this.onCheckPrimaryService();
          }
          this.showHideSpinner(false, isShowSpinner);
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          if (err.status == 0 && !isBulkService && !this.localService.isPrimaryServiceDown) {
            this.showHideSpinner(false, isShowSpinner);
            this.localService.isPrimaryServiceDown = true;
            this.localService.showInformationByStatus(Status.ErrorOccured, true);
            this.onEnsureServiceDown();
          } else {
            this.onErrorHandling(err, isShowSpinner);
          }
          throw err;
        }));
    }
  }

  onCheckPrimaryService() {
    const isPrimaryServiceDownBefore = this.localService.isPrimaryServiceDown;
    this.request_general_get(environment.url.service + 'version').subscribe(result => {
      this.localService.isPrimaryServiceDown = !(result && result.version && result.version.length > 5);

      setTimeout(() => {
        if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
          this.onEnsureServiceDown();
        }
      }, this.localService.isPrimaryServiceDown ? 100 : 0);
    });
  }

  onEnsureServiceDown(serviceApiType: ServiceApiType = ServiceApiType.CurrentApplication) {
    this.request_general_post(this.controllerNameConfiguration + this.methodsConfiguration.EnsureDownTimeLog, undefined, false).subscribe(result => {
    });
  }

  printToAndroid(html: string) {
    const printUrl = 'http://127.0.0.1:8080/print';
    const formData = new FormData();
    formData.append('postData', html);   // NanoHTTPD expects 'postData'

    return this.httpCall.post(printUrl, formData, {
      responseType: 'text'   // Important!
    });
  }

  request_general_get(url) {
    if (this.localService.isInternetAvailable) {
      const isPrimaryServiceDownBefore = this.localService.isPrimaryServiceDown;
      return Observable.create(observer => this.httpCall.get(url).subscribe(
        data => {
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          this.localService.isPrimaryServiceDown = true;
          if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
            this.onEnsureServiceDown();
          }
        }));
    }
  }

  request_general_post_by_service_type(serviceUrl: string, controllerMethod: string, body?, isShowSpinner = true, isEncryptBody = true, isForceBackupService = false) {
    const generalOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'POST',
        'Access-Control-Max-Age': '300',
        'Access-Control-Allow-Methods': '*'
      })
    };
    let encryptedBody = isEncryptBody ? this.localService.encryptCrypto(JSON.stringify(body)) : body;
    this.showHideSpinner(true, isShowSpinner);
    const url = serviceUrl + controllerMethod;
    return Observable.create(observer => this.httpCall.post(url, { "val": encryptedBody }, generalOptions).subscribe(
      data => {
        this.showHideSpinner(false, isShowSpinner);
        observer.next(data);
        observer.complete();
      },
      (err: HttpErrorResponse) => {
        if (err.status == 0) {
          this.showHideSpinner(false, isShowSpinner);
          this.localService.showInformationByStatus(Status.ErrorOccured);
        } else {
          this.onErrorHandling(err, isShowSpinner);
        }
        observer.error(err);
        observer.complete();
      }));
  }


  getServiceUrlBackup(serviceApiType: ServiceApiType): string {
    let rtn = '';
    switch (serviceApiType) {
      case ServiceApiType.LazyDigiSol: {

      } break;
      case ServiceApiType.LazyDigiSolBulk: {

      } break;
      case ServiceApiType.CurrentApplication: {
        rtn = environment.url.service;
      } break;
      case ServiceApiType.CurrentApplicationBulk: {
        rtn = environment.url.bulk_service;
      } break;
    }
    if (!rtn.endsWith('/')) {
      rtn = rtn + '/';
    }
    return rtn;
  }

  request_general_get_by_type(serviceUrl: string, controllerMethod: string, isShowSpinner = true) {
    this.showHideSpinner(true, isShowSpinner);
    const url = serviceUrl + controllerMethod;
    return Observable.create(observer => this.httpCall.get(url).subscribe(
      data => {
        this.showHideSpinner(false, isShowSpinner);
        observer.next(data);
        observer.complete();
      },
      (err: HttpErrorResponse) => {
        this.showHideSpinner(false, isShowSpinner);
        observer.error(err);
        observer.complete();
      }));
  }

  getServiceUrl(serviceApiType: ServiceApiType, overWriteUrl?: string): string {
    let rtn = '';
    switch (serviceApiType) {
      case ServiceApiType.LazyDigiSol: {

      } break;
      case ServiceApiType.LazyDigiSolBulk: {

      } break;
      case ServiceApiType.CurrentApplication: {
      } break;
      case ServiceApiType.CurrentApplicationBulk: {
      } break;
    }
    if (!rtn.endsWith('/')) {
      rtn = rtn + '/';
    }
    return rtn;
  }


  isServiceUp(serviceApiType: ServiceApiType): boolean {
    let rtn: boolean = true;
    // const item = this.localService.serviceApiStatus.find(x => x.serviceApiType == serviceApiType);
    // if (item) {
    //   rtn = item.isUp == true;
    // } else {
    //   this.localService.serviceApiStatus.push({
    //     serviceApiType: serviceApiType,
    //     isUp: true
    //   } as ServiceApiStatus);
    // }
    return rtn;
  }

  setServiceStatus(serviceApiType: ServiceApiType, isUp: boolean): void {
    // const item = this.localService.serviceApiStatus.find(x => x.serviceApiType == serviceApiType);
    // if (item) {
    //   this.localService.serviceApiStatus.find(x => x.serviceApiType == serviceApiType).isUp == true;
    // } else {
    //   this.localService.serviceApiStatus.push({
    //     serviceApiType: serviceApiType,
    //     isUp: isUp
    //   } as ServiceApiStatus);
    // }
  }

  request_general_post_blob_response(controller, body, isShowSpinner = true, isBulkService: boolean = false) {
    switch (environment.service_type) {
      case ServiceType.DotNet: {

        this.showHideSpinner(true, isShowSpinner);
        if (body && body.pag) {
          body.pag = this.convertFromPaging(body.pag);
        }
        let encryptedBody = this.localService.reques ? this.localService.encryptCrypto(JSON.stringify(body)) : JSON.stringify(body);
        return Observable.create(observer => this.httpCall.post((isBulkService ? environment.url.bulk_service : environment.url.service) + controller, environment.service_type == ServiceType.DotNet ? encryptedBody : { "val": encryptedBody }, {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }), responseType: 'blob'
        }).subscribe(
          data => {
            this.showHideSpinner(false, isShowSpinner);
            observer.next(data);
            observer.complete();
          }, (err: HttpErrorResponse) => {
            this.onErrorHandling(err, isShowSpinner);
          }));
      } break;
      default: {
        return this.request_general_post(controller, body, isShowSpinner, false, isBulkService);
      } break;
    }
  }

  showHideSpinner(isShow: boolean, isSpinnerCalculate: boolean) {
    if (isSpinnerCalculate) {
      if (isShow) {
        if (this.activeServiceCallsCount == 0)
          this.spinner.show();
        this.activeServiceCallsCount = this.activeServiceCallsCount + 1;
      } else {
        this.activeServiceCallsCount = this.activeServiceCallsCount - 1;
        if (this.activeServiceCallsCount == 0) {
          this.spinner.hide();
        }
      }
    }
  }

  onErrorHandling(err: HttpErrorResponse, isShowSpinner: boolean) {
    this.showHideSpinner(false, isShowSpinner);
    if (isShowSpinner && this.localService && this.localService.languageContent)
      this.localService.showInformation(this.localService.languageContent.common.response_failed);
    //switch (err.status) {
    //  case 503: {
    //  } break;
    //  default: {

    //  } break;
    //}
  }


  convertFromPaging(paging: Paging): KeyValues15 {
    if (paging && paging.currentPage) {
      let rtn = {
        v1: paging.currentPage.toString(),
        v2: paging.dataPerPage.toString(),
        //v3: paging.dateFrom,
        v4: paging.dateFromS,
        //v5: paging.dateTo,
        v6: paging.dateToS,
        v7: paging.isAutoRefresh ? '1' : '0',
        v8: paging.isReverseOrder ? '1' : '0',
        v9: paging.pageType.toString(),
        v10: paging.searchKey.toString(),
        v11: paging.searchType.toString(),
        v12: paging.searchTypes ? JSON.stringify(paging.searchTypes) : '',
        v13: paging.totalCount.toString(),
        v14: paging.totalPage.toString(),
        v15: paging.data ? JSON.stringify(paging.data) : ''
      } as KeyValues15;
      return rtn;
    } else
      return null;
  }
}
